(() => {
  if (customElements.get('py-video-feed')) return;
  const placeLibrary = () => {
    const library = document.getElementById('shopify-section-py-video-library');
    const slot = document.querySelector('.py-reels-slot');
    if (!library || !slot) return;
    const section = slot.closest('[id^="shopify-section-"]');
    if (section && section.previousElementSibling !== library) section.before(library);
    library.classList.add('is-placed');
    slot.hidden = !!library.querySelector('py-video-feed');
  };
  document.addEventListener('shopify:section:load', placeLibrary);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeLibrary, {once:true});
  else placeLibrary();
  customElements.define('py-video-feed', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.dialog = this.querySelector('dialog');
      this.player = this.dialog.querySelector('video');
      this.sound = this.querySelector('.py-reels__sound');
      this.setupCoverFlow(options);
      this.addEventListener('click', e => {
        const trigger = e.target.closest('.py-reels__open');
        if (!trigger) return;
        this.preview?.pause();
        this.trigger = trigger;
        this.modalIndex = this.cards.indexOf(trigger.closest('.py-reels__card')) % this.sourceCards.length;
        this.loadModalVideo(true);
        this.dialog.showModal();
        this.oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.player.play().catch(() => {});
      }, options);
      this.querySelector('.py-reels__prev')?.addEventListener('click', () => this.stepVideo(-1), options);
      this.querySelector('.py-reels__next')?.addEventListener('click', () => this.stepVideo(1), options);
      this.dialog.addEventListener('keydown', e => {
        if (e.target === this.player) return;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault(); this.stepVideo(e.key === 'ArrowLeft' ? -1 : 1);
        }
      }, options);
      this.querySelector('.py-reels__close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', e => { if (e.target === this.dialog) this.dialog.close(); }, options);
      this.dialog.addEventListener('close', () => {
        this.player.pause(); this.player.muted = true;
        document.documentElement.style.overflow = this.oldOverflow ?? '';
        this.trigger?.focus({ preventScroll: true });
        this.syncPreview();
      }, options);
      const syncSound = () => {
        this.sound.setAttribute('aria-pressed', String(!this.player.muted));
      };
      this.sound.addEventListener('click', () => { this.player.muted = !this.player.muted; syncSound(); }, options);
      this.player.addEventListener('volumechange', syncSound, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.player.pause(); this.syncPreview(); }, options);
    }
    loadModalVideo(resetMute = false) {
      const source = this.sourceCards[this.modalIndex].querySelector('template').content.querySelector('video');
      this.player.pause();
      this.player.replaceChildren(...[...source.querySelectorAll('source')].map(n => n.cloneNode(true)));
      this.player.removeAttribute('src');
      if (source.getAttribute('src')) this.player.src = source.getAttribute('src');
      this.player.poster = source.poster;
      const caption = this.sourceCards[this.modalIndex].dataset.caption || '';
      const captionEl = this.dialog.querySelector('.py-reels__dialog-caption');
      if (captionEl) { captionEl.textContent = caption; captionEl.hidden = !caption; this.dialog.classList.toggle('has-caption', !!caption); }
      if (resetMute) this.player.muted = true;
      this.player.load();
    }
    stepVideo(delta) {
      this.modalIndex = (this.modalIndex + delta + this.sourceCards.length) % this.sourceCards.length;
      this.loadModalVideo();
      this.player.play().catch(() => {});
    }
    setupCoverFlow(options) {
      this.track = this.querySelector('.py-reels__track');
      this.track.querySelectorAll('[data-loop-copy]').forEach(card => card.remove());
      this.sourceCards = [...this.track.querySelectorAll('.py-reels__card')];
      if (this.sourceCards.length > 1) {
        const copy = card => {
          const clone = card.cloneNode(true);
          clone.dataset.loopCopy = 'true';
          clone.removeAttribute('id');
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
          return clone;
        };
        this.track.prepend(...this.sourceCards.map(copy));
        this.track.append(...this.sourceCards.map(copy));
      }
      this.cards = [...this.track.querySelectorAll('.py-reels__card')];
      const browse = direction => this.track.scrollBy({left: direction * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
      this.querySelector('.py-reels__browse--prev')?.addEventListener('click', () => browse(-1), options);
      this.querySelector('.py-reels__browse--next')?.addEventListener('click', () => browse(1), options);
      this.mobile = matchMedia('(max-width:767px)');
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.preview = document.createElement('video');
      this.preview.className = 'py-reels__preview';
      this.preview.muted = true;
      this.preview.loop = true;
      this.preview.playsInline = true;
      this.preview.setAttribute('muted', '');
      this.preview.setAttribute('playsinline', '');
      this.preview.setAttribute('aria-hidden', 'true');
      this.preview.preload = 'none';
      this.preview.addEventListener('playing', () => this.preview.classList.add('is-playing'), options);
      this.visible = false;
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.syncPreview();
      }, {threshold: .35});
      this.observer.observe(this);
      const layout = () => {
        this.preview.pause();
        this.classList.toggle('is-coverflow', this.mobile.matches);
        if (!this.mobile.matches) this.preview.remove();
        requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const middle = this.sourceCards.length > 1 ? this.sourceCards.length : 0;
          const card = this.cards[middle + ((this.activeIndex ?? 0) % this.sourceCards.length)];
          if (!card) return;
          this.track.scrollLeft += card.getBoundingClientRect().left + card.offsetWidth / 2
            - this.track.getBoundingClientRect().left - this.track.clientWidth / 2;
          this.updateCenter();
        });
      };
      this.track.addEventListener('scroll', () => {
        this.preview.pause();
        clearTimeout(this.settle);
        this.settle = setTimeout(() => { this.normalizeLoop(); this.updateCenter(); }, 160);
        const center = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
        this.cards.forEach(card => {
          const delta = (card.getBoundingClientRect().left + card.offsetWidth / 2 - center) / card.offsetWidth;
          card.style.setProperty('--distance', Math.min(Math.abs(delta), 1));
          card.style.setProperty('--turn', `${Math.max(-1, Math.min(1, delta)) * -12}deg`);
        });
      }, {...options, passive:true});
      this.cards.forEach((card, index) => {
        card.addEventListener('pointerenter', () => {
          if (this.mobile.matches) return;
          this.hoverIndex = index;
          this.activeIndex = index;
          this.syncPreview();
        }, options);
        card.addEventListener('pointerleave', () => {
          if (this.mobile.matches) return;
          this.hoverIndex = null;
          this.preview.pause();
          this.preview.classList.remove('is-playing');
        }, options);
      });
      this.mobile.addEventListener('change', layout, options);
      this.reduced.addEventListener('change', () => this.syncPreview(), options);
      window.addEventListener('resize', layout, options);
      layout();
    }
    normalizeLoop() {
      const count = this.sourceCards.length;
      if (count < 2) return;
      const span = this.cards[count].offsetLeft - this.cards[0].offsetLeft;
      if (!span) return;
      const x = this.track.scrollLeft;
      if (x < span * .5 || x > span * 1.5) {
        const delta = x < span * .5 ? span : -span;
        this.track.scrollTo({left: x + delta, behavior: 'instant'});
      }
    }
    updateCenter() {
      if (!this.mobile.matches) return;
      const center = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
      let nearest = 0, distance = Infinity;
      this.cards.forEach((card, index) => {
        const delta = (card.getBoundingClientRect().left + card.offsetWidth / 2 - center) / card.offsetWidth;
        card.style.setProperty('--distance', Math.min(Math.abs(delta), 1));
        card.style.setProperty('--turn', `${Math.max(-1, Math.min(1, delta)) * -12}deg`);
        if (Math.abs(delta) < distance) { distance = Math.abs(delta); nearest = index; }
      });
      this.cards.forEach((card, i) => card.classList.toggle('is-active', i === nearest));
      this.activeIndex = nearest;
      this.syncPreview();
    }
    syncPreview() {
      if (!this.preview) return;
      if ((!this.mobile.matches && this.hoverIndex == null) || !this.visible || this.dialog.open || document.hidden || this.reduced.matches) {
        this.preview.pause(); return;
      }
      const card = this.cards[this.activeIndex];
      if (!card) return;
      if (this.preview.parentElement !== card.querySelector('.py-reels__open')) {
        this.preview.pause();
        this.preview.classList.remove('is-playing');
        const source = card.querySelector('template').content.querySelector('video');
        this.preview.replaceChildren(...[...source.querySelectorAll('source')].map(n => n.cloneNode(true)));
        this.preview.removeAttribute('src');
        if (source.getAttribute('src')) this.preview.src = source.getAttribute('src');
        this.preview.poster = source.poster;
        card.querySelector('.py-reels__open').append(this.preview);
        this.preview.load();
      }
      this.preview.muted = true;
      this.preview.play().catch(() => {});
    }
    disconnectedCallback() {
      if (this.dialog?.open) { this.dialog.close(); document.documentElement.style.overflow = this.oldOverflow ?? ''; }
      this.preview?.pause();
      this.preview?.remove();
      this.track?.querySelectorAll('[data-loop-copy]').forEach(card => card.remove());
      this.observer?.disconnect();
      clearTimeout(this.settle);
      this.player?.pause();
      this.abort?.abort(); this.abort = null;
    }
  });
})();
